module.exports = __webpack_public_path__ + "static/img/02.385cb9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Parts/Key3D/temp/02.png
// module id = 536
// module chunks = 0